export default __webpack_public_path__ + "static/media/1.1ded4f88.webp";